import { useMemo } from "react";

import useTableSort from "components/Table/useTableSort";

import {
  INITIAL_SORT_DIRECTION,
  INITIAL_SORT_OPTION,
  MODULE_VERSION_CONSUMERS_TABLE_FILTERS_STORAGE_KEY,
  SORT_CONFIG,
} from "./constants";
import { sortModuleVersionConsumers } from "./helpers";
import { ModuleVersionConsumerRow } from "./types";

export const useSortingModuleVersionConsumers = (consumers: ModuleVersionConsumerRow[] = []) => {
  const { sortDescriptor } = useTableSort({
    filtersOrderSettingsKey: MODULE_VERSION_CONSUMERS_TABLE_FILTERS_STORAGE_KEY,
    sortConfig: SORT_CONFIG,
    initialSortOption: INITIAL_SORT_OPTION,
    initialSortDirection: INITIAL_SORT_DIRECTION,
  });

  return useMemo(
    () => sortModuleVersionConsumers(consumers, sortDescriptor),
    [consumers, sortDescriptor]
  );
};
